import { MdOutlineDirectionsCarFilled } from 'react-icons/md'
import TwoWheelerIcon from '@mui/icons-material/TwoWheeler'
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined'
import WorkOutlineOutlinedIcon from '@mui/icons-material/WorkOutlineOutlined'
import AgricultureIcon from '@mui/icons-material/Agriculture'
import bb_truck from 'assets/images/images_oficial/caminhao.jpg'
import bb_bike from 'assets/images/images_oficial/moto.jpg'
import bb_car from 'assets/images/images_oficial/auto.jpg'
import bb_house from 'assets/images/images_oficial/imoveis.jpg'
import bb_services from 'assets/images/images_oficial/sustentaveis.jpg'
import bb_eletro from 'assets/images/images_oficial/eletro.jpg'

export enum PERSON_TYPE {
  Juridico = 'J',
  Fisico = 'F'
}

export const universal_image = bb_eletro

export const MANAGEMENT_PROPOSALS_STATUS = [
  { label: 'Alocadas', value: 'qt_alocadas', color: '#1856FF', filter: 'alocadas' },
  { label: 'Não alocadas', value: 'qt_nalocadas', color: '#883DCF', filter: 'nao-alocadas' },
  { label: 'Canceladas', value: 'qt_canceladas', color: '#FF0000', filter: 'canceladas' }
]

export const productMidia = [
  {
    nm_produto: ['MOTOCICLETAS', 'MOTO', 'MOTOS'],
    icon: <TwoWheelerIcon style={{ color: '#1856ff', fontSize: '26px' }} />,
    cd_segmento_bem: 'IV',
    image: bb_bike
  },
  {
    nm_produto: ['IMOVEIS', 'IMÓVEIS'],
    icon: <HomeOutlinedIcon style={{ color: '#1856ff', fontSize: '26px' }} />,
    cd_segmento_bem: 'I',
    image: bb_house
  },
  {
    nm_produto: ['SERVIÇOS'],
    icon: <WorkOutlineOutlinedIcon style={{ color: '#1856ff', fontSize: '26px' }} />,
    cd_segmento_bem: 'VI',
    image: bb_services
  },
  {
    nm_produto: ['AUTOMOVEIS', 'AUTO', 'CARROS', 'CARRO'],
    icon: <MdOutlineDirectionsCarFilled style={{ color: '#1856ff', fontSize: '26px' }} />,
    cd_segmento_bem: 'III',
    image: bb_car
  },
  {
    nm_produto: ['TRATOR E CAMINHÃO', 'TRATOR', 'TRATORES', 'CAMINHÃO', 'CAMINHÕES'],
    icon: <AgricultureIcon style={{ color: '#1856ff', fontSize: '26px' }} />,
    cd_segmento_bem: 'II',
    image: bb_truck
  }
]

export const PROPOSAL_STATUS = {
  alocada: 'A',
  nao_alocada: 'N',
  cancelada: 'C'
}

export const PAYMENT_TYPE = {
  BB: 'Boleto bancário',
  DB: 'Debito em conta'
}

export const GENDER_SELECT = [
  { value: 'M', label: 'Masculino' },
  { value: 'F', label: 'Feminino' }
]

export const SN_SELECT = [
  { value: 'S', label: 'Sim' },
  { value: 'N', label: 'Não' }
]

export const DATE_SERVER = '0001-01-01T00:00:00'
